module.exports = __webpack_public_path__ + "img/56.9.TU.08de7732.png";